import { ListColumnHeaderComponent } from '../list.column.header.component';

export class ListColumnHeaderSortEvent {
    public column: ListColumnHeaderComponent;
    public isAsc: boolean;

    constructor(column: ListColumnHeaderComponent, isAsc: boolean) {
        this.column = column;
        this.isAsc = isAsc;
    }
}




// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/list/column.header/events/sort.event.ts